import { ConnectorEntity } from "./ConnectorEntity";
import { UserEntity } from "./UserEntity";

export type PreAuth = {
  value: number;
  charge_status: string;
};

export type SessionEntity = {
  id: number;
  user_id: string;
  charger_id: string;
  charger_connector_id: string;
  payment_method: string;
  status: SessionStatus;
  charged_amount: string | null;
  value: string | null;
  idle_mins: string | null;
  idle_value: string | null;
  started_at: string | null;
  finished_at: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  card_id: string | null;
  payment_status: string;
  connector: ConnectorEntity;
  user: Omit<UserEntity, "sessions_count" | "address">;
  ocpp_events: OcppEvent[];
  pre_auth?: PreAuth | null;
};

export enum SessionStatuses {
  pending = "pending",
  charging = "charging",
  canceled = "canceled",
  concluded = "concluded",
}

export type SessionStatus = keyof typeof SessionStatuses;
export type PaymentStatus = "pending" | "failed" | "partial" | "paid";

export type OcppEvent = {
  id: string;
  charger_id: string;
  charge_session_id: number;
  message_type: string;
  unique_id: string;
  action: string;
  payload: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  connector_id: string | null;
  charged_amount: number | null;
  battery_perc: number | null;
  status: string | null;
};
